import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Layout from "./components/App";
import MainLayout from "./components/layout/MainLayout";
import About from "./components/page/about/About";
import Contact from "./components/page/contact/Contact";
import ErrorPage from "./components/page/error/ErrorPage";
import Project from "./components/page/project/Project";
import Service from "./components/page/service/Service";
import ServiceDetails from "./components/page/ServiceDetails/ServiceDetails";
import "./index.css"
import { useEffect } from 'react';

const RedirectToExternalPage = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null;
};

//Default Warniing Error Hide
console.log = console.warn = console.error = () => {};

/*
=>version : 0.1
=>Event : Rendering al content to web
=>Action: define all routes and page
@return HTML
*/

function Root() {
  return <>
  <BrowserRouter basename="/">
    <Switch>
      {/*main layout*/}
      <Route exact path="/" component={MainLayout} />
      {/* secound layout */}
      {/* <Route exact path="/index2" component={HomePageTwo} /> */}
      {/* all inner page load layout component */}
      <Layout>
        {/* <Route
          exact
          path={`${process.env.PUBLIC_URL}/about-us`}
          component={AboutPage}
        /> */}
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/about-us`}
          component={About}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/contact-us`}
          component={Contact}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/error`}
          component={ErrorPage}
        />
        {/* <Route
          exact
          path={`${process.env.PUBLIC_URL}/blog`}
          component={BlogSidebar}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/blog-standard`}
          component={BlogStandard}
        /> */}
        {/* <Route
          exact
          path={`${process.env.PUBLIC_URL}/blog-details`}
          component={BlogDetails}
        /> */}
          
          <Route
  exact
  path={`${process.env.PUBLIC_URL}/consult/arjun`}
  render={() => <RedirectToExternalPage url="https://calendly.com/arjun-zcax/dlplatforms" />}
/>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/services`}
          component={Service}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/services-details`}
          component={ServiceDetails}
        />
        {/* <Route
          exact
          path={`${process.env.PUBLIC_URL}/projects/collegetiffin`}
          component={ProjectDetails}
          />
          <Route
          exact
          path={`${process.env.PUBLIC_URL}/projects/dlupload`}
          component={ProjectDetails}
          />
          <Route
          exact
          path={`${process.env.PUBLIC_URL}/projects/kakshya`}
          component={ProjectDetails}
        /> */}
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/projects`}
          component={Project}
          />
          

        {/* <Route
          exact
          path={`${process.env.PUBLIC_URL}/team`}
          component={Team}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/pricing`}
          component={Pricing}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/faq`}
          component={Faq}
        /> */}
        {/* 
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/team`}
          component={TeamPage}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/feedback`}
          component={FeedbackPage}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/faq`}
          component={FaqPage}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/error`}
          component={ErrorPage}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/blog-grid`}
          component={BlogGridPage}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/blog-sidebar`}
          component={BlogSidebarPage}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/blog-details`}
          component={BlogDetailsPage}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/projects`}
          component={ProjectPage}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/projects-details`}
          component={ProjectDetailsPage}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/services`}
          component={ServicePage}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/services-details`}
          component={ServiceDetailsPage}
        /> */}
      </Layout>
    </Switch>
  </BrowserRouter>
</>
}

export default Root;

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById("root")
);
